import { authService } from '@/features/auth/api/authService.js';
import { persistDisplayScale } from '@/composables/useDisplayScale.js';

// 結束系統：呼叫登出 API 使後端使 refreshToken 失效，接著清除本機端所有登入/暫存資料後導回登入頁
// 不呼叫 refresh token API，改用整頁導頁讓 Pinia store 隨程式重啟一併清空記憶體狀態
export async function exitProgram() {
  try {
    await authService.logout();
  } catch (err) {
    // 登出 API 失敗不阻擋離開流程，本機端狀態仍會清除
    console.warn(
      '[exitProgram] logout failed:',
      err?.response?.status || err?.message,
    );
  }

  localStorage.clear();
  sessionStorage.clear();
  // 顯示比例不屬於登入資料，登出後保留
  persistDisplayScale();
  window.location.href = '/login';
}
